import { parseQueryParams } from '@/utils/queryParams';

/**
 * The auction house a results page is a search of: filtered to exactly one house, with no keyword.
 * A list of houses (`house_id=1,2`) is a filter, not one seller's search.
 */
export const getSellerSearchHouseId = (search: string): number | undefined => {
    const { house_id: houseId, keyword } = parseQueryParams(search);

    if (keyword || !/^\d+$/.test(houseId ?? '')) {
        return undefined;
    }
    return Number(houseId);
};
